import AxiosInstance from "./api";

export const SecuritiesPortfolioService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/securities-portfolio/paginate", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/securities-portfolio/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/securities-portfolio/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/securities-portfolio", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/securities-portfolio/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/securities-portfolio/" + id);
  },
};
